module.exports = __webpack_public_path__ + "static/media/PRINT_LABEL.cbfc6ce9.svg";